module.exports = __webpack_public_path__ + "static/media/12UNCTAD20.4e4d9d98.jpg";